import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useCoachPrivateProfileRequired } from "~/contexts/coach";
import { MembershipPlan } from "~/lib/schemas";
import { OfferForm, getOfferData } from "~/components/forms/offer-form";

export const Route = createFileRoute(
  "/coach/_backend/edit-profile/offers/$offerId/",
)({
  component: OfferEditPage,
});

function OfferEditPage() {
  const coach = useCoachPrivateProfileRequired();
  const { offerId } = Route.useParams();

  // Only ProPlus members can edit additional offers
  if (
    offerId !== coach.mainOfferId &&
    coach.membershipPlan !== MembershipPlan.ProPlus
  ) {
    throw new Error("Only ProPlus members can edit additional offers");
  }

  const { data: offer } = useQuery({
    queryKey: ["offer", offerId],
    queryFn: () => getOfferData({ data: { coachId: coach.id, offerId } }),
  });

  if (!offer) {
    return <div>Loading...</div>;
  }

  return (
    <OfferForm
      initialData={offer}
      title={offer.id ? "Edit Offer" : "Create New Offer"}
    />
  );
}
